<template>
  <div
    class="tw:flex-col tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mr-auto tw:ml-auto tw:min-h-screen-minus-header-and-footer">
    <div
      class="tw:flex-col tw:flex tw:w-full tw:md:max-w-(--tw-breakpoint-lg) tw:lg:max-w-(--tw-breakpoint-xl) tw:mr-auto tw:ml-auto tw:mb-8">
      <AppMenu :data="navEntries" :loading="false" />
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, onBeforeRouteUpdate } from 'vue-router'
import AppMenu from '@/components/appMenu/AppMenu.vue'

/** Navigation menu entry */
interface NavEntry {
  label: string
  route: string
  testId: string
}

const router = useRouter()

/** Property details navigation tabs */
const navEntries: NavEntry[] = [
  {
    label: 'app_hotel_details_basic_information',
    route: '/property-details/basic-information',
    testId: 'property-details-basic-information',
  },
  {
    label: 'app_images',
    route: '/property-details/images',
    testId: 'property-details-images',
  },
  {
    label: 'app_description',
    route: '/property-details/description',
    testId: 'property-details-description',
  },
]

/**
 * Prevent direct access to /property-details
 * Auto-redirect to basic-information tab
 */
onBeforeRouteUpdate((to, from) => {
  // Prevent navigation if already in property-details and trying to go to root
  if (from.path.includes('/property-details') && to.path === '/property-details') {
    return false
  }

  // Redirect /property-details to first tab
  if (to.path === '/property-details') {
    return '/property-details/basic-information'
  }
})

onMounted(() => {
  goToBasicInfo()
})

/**
 * Navigate to basic information tab if on root property-details route
 */
const goToBasicInfo = (): void => {
  if (router.currentRoute.value.name === 'property-details') {
    router.push('/property-details/basic-information')
  }
}
</script>
